
export const environment = {
    version: '1.0.23',
    production: false,
    serviceWorkerEnabled: true,
    updateCheckInterval: 10 * 60 * 1000, // 10 minutes

    apiUrl: 'https://qa.api.americandronenetwork.com',
    webSocketUrl: 'wss://qa.api.americandronenetwork.com',

    appCDN: 'https://qa.cdn.americandronenetwork.com',
    // Brand assets (logos). Same host in every environment.
    staticCDN: 'https://static-cdn.americandronenetwork.com',

    firebase: {
        apiKey: "AIzaSyCE0BJ9oFLQxOPvmgZCz4VrQcaBZm27Rc0",
        authDomain: "american-drone-network-qa.firebaseapp.com",
        projectId: "american-drone-network-qa",
        storageBucket: "american-drone-network-qa.firebasestorage.app",
        messagingSenderId: "171047914869",
        appId: "1:171047914869:web:d3b9d71647820cd438173c",
        measurementId: "G-NXL6K8LKWL"
    }
}
